import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { store } from './store';

const app = ReactDOM.createRoot(document.getElementById('app'));

app.render(
	<Provider store={store}>
		<Router>
			{/* <StrictMode> */}
			<App />
			{/* </StrictMode> */}
		</Router>
	</Provider>
);
